"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Asset_1 = require("./Asset");
var ImageAsset = (function (_super) {
    tslib_1.__extends(ImageAsset, _super);
    function ImageAsset(rawData, version) {
        if (rawData === void 0) { rawData = {}; }
        return _super.call(this, Asset_1.AssetType.Image, rawData, version) || this;
    }
    Object.defineProperty(ImageAsset.prototype, "width", {
        get: function () {
            return this._rawData.w;
        },
        set: function (width) {
            this._rawData.w = width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageAsset.prototype, "height", {
        get: function () {
            return this._rawData.h;
        },
        set: function (height) {
            this._rawData.h = height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageAsset.prototype, "image", {
        get: function () {
            return this._rawData.p;
        },
        set: function (image) {
            this._rawData.p = image;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageAsset.prototype, "path", {
        get: function () {
            return this._rawData.u;
        },
        set: function (path) {
            this._rawData.u = path;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageAsset.prototype, "embedded", {
        get: function () {
            if (this._rawData.e) {
                return this._rawData.e === 1;
            }
            return undefined;
        },
        set: function (embedded) {
            this._rawData.e = (embedded ? 1 : 0);
        },
        enumerable: true,
        configurable: true
    });
    ImageAsset.prototype.toJSON = function () {
        return tslib_1.__assign(tslib_1.__assign({}, _super.prototype.toJSON.call(this)), { width: this.width, height: this.height, path: this.path, image: this.image, embedded: this.embedded });
    };
    return ImageAsset;
}(Asset_1.Asset));
exports.ImageAsset = ImageAsset;
//# sourceMappingURL=ImageAsset.js.map